import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  commentItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1.5),
    borderRadius: 8,
    backgroundColor: theme.palette.grey[50],
    border: `1px solid ${theme.palette.grey[200]}`,
  },
  replyItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(1),
    borderRadius: 6,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.grey[200]}`,
    borderLeft: `3px solid ${theme.palette.primary.light}`,
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  commentHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  commentMeta: {
    fontSize: 11,
    color: theme.palette.text.secondary,
  },
  replyIcon: {
    marginRight: 4,
    verticalAlign: 'middle',
  },
  editedLabel: {
    fontStyle: 'italic',
  },
  actions: {
    display: 'flex',
    gap: 2,
  },
  repliesActions: {
    marginTop: 4,
    marginLeft: 24,
    gap: 4,
  },
  inheritColor: {
    color: 'inherit',
  },
}))

export default useStyles
